import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Default statuses - users can customize in settings
export const DEFAULT_ASSESSMENT_STATUSES = [
  "Referral Received",
  "Assessment Scheduled",
  "Forms Sent",
  "Assessment Completed",
  "Awaiting Information",
  "Report in Progress",
  "Report Sent",
  "Follow-up Booked",
  "Follow-up Completed",
  "Materials Uploaded",
  "File Closed"
];

export const FORM_STATUSES = ["Not Sent", "Sent", "Received", "Scored"];

export const getStatusClass = (status) => {
  const statusMap = {
    "Referral Received": "status-referral",
    "Assessment Scheduled": "status-scheduled",
    "Forms Sent": "status-forms-sent",
    "Assessment Completed": "status-assessment",
    "Awaiting Information": "status-review",
    "Report in Progress": "status-ready",
    "Report Sent": "status-sent",
    "Follow-up Booked": "status-feedback",
    "Follow-up Completed": "status-completed",
    "Materials Uploaded": "status-archived",
    "File Closed": "status-closed",
  };
  return statusMap[status] || "status-referral";
};

export const getFormStatusClass = (status) => {
  const statusMap = {
    "Not Sent": "form-not-sent",
    "Sent": "form-sent",
    "Received": "form-received",
    "Scored": "form-scored",
  };
  return statusMap[status] || "form-not-sent";
};

export const getPaymentStatusClass = (status) => {
  return status === "Paid" ? "payment-paid" : "payment-not-paid";
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
};

export const getDaysUntil = (dateStr) => {
  if (!dateStr) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const targetDate = new Date(dateStr);
  targetDate.setHours(0, 0, 0, 0);
  const diffTime = targetDate - today;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const getStatusIndex = (status, statuses) => {
  return (statuses || DEFAULT_ASSESSMENT_STATUSES).indexOf(status);
};
